function flipSlides(swiper) {
  const { slides, rtlTranslate: rtl, activeIndex } = swiper;

  const step = slides[activeIndex]?.progress;
  let n = step > 0 ? Math.ceil(step) : Math.floor(step);
  let nextIndex = activeIndex + n;
  let dir = 0; // -1: 减少 1: 增加

  if (n === step && n !== 0) {
    dir = n < 0 ? -1 : 1;
  }

  for (let i = 0; i < slides.length; i += 1) {
    const $slideEl = slides.eq(i);
    let progress = $slideEl[0]?.progress;
    if (progress === undefined) continue;

    const offset = $slideEl[0].swiperSlideOffset;
    let rotateX = 0;
    let rotateY = 0;
    let tx = -1 * offset;
    let ty = 0;

    let swiperSlideRotate = $slideEl[0].swiperSlideRotate;
    if (swiperSlideRotate === undefined) {
      if (i === activeIndex) {
        swiperSlideRotate = 0;
      } else {
        swiperSlideRotate = i > activeIndex ? 180 : -180;
      }
      rotateY = swiperSlideRotate;
    } else {
      // 非交互的幻灯片，保持在背面不旋转
      if (i !== activeIndex && i !== nextIndex) {
        if (Math.abs(swiperSlideRotate % 360) === 180) {
          continue;
        }
        if (swiperSlideRotate === 0) {
          swiperSlideRotate = i > activeIndex ? 180 : -180;
        }
        rotateY = Math.round(swiperSlideRotate / 180) * 180;
      } else {
        // 跳转到某个幻灯片时
        if (dir !== 0) {
          // 下一个节点角度为0，当前节点根据方向判断角度
          if (nextIndex === i) rotateY = 0;
          else rotateY = dir > 0 ? -180 : 180;

          if (dir < 0) {
            // 减少
            let n = rotateY - swiperSlideRotate;
            if (n > 180 || n < 0) {
              rotateY = rotateY + Math.ceil(swiperSlideRotate / 360) * 360;
            }
          } else {
            let n = swiperSlideRotate - rotateY;
            if (n > 180 || n < 0) {
              rotateY = rotateY + Math.floor(swiperSlideRotate / 360) * 360;
            }
          }
        } else {
          progress = Math.max(Math.min(progress, 1), -1);
          rotateY = progress ? -180 * progress : 0;
        }
      }
    }

    if (!swiper.isHorizontal()) {
      ty = tx;
      tx = 0;
      rotateX = -1 * rotateY;
      rotateY = 0;
    } else if (rtl) {
      rotateY = -1 * rotateY;
    }

    $slideEl[0].swiperSlideRotate = rotateY;
    $slideEl.transform(
      `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`
    );
  }
}
function handleSetTranslate() {
  flipSlides(this);
}

function handleSetTransition(duration) {
  const { slides, activeIndex, $wrapperEl } = this;
  let flag = Math.abs(slides[activeIndex]?.progress || 0) > 1;

  slides.transition(duration);
  if (this.params.virtualTranslate && duration !== 0) {
    let eventTriggered = false;
    slides.eq(activeIndex).transitionEnd(() => {
      if (eventTriggered) return;
      if (!this || this.destroyed) return;
      if (flag) {
        flipSlides(this);
      }
      eventTriggered = true;
      this.animating = false;
      const triggerEvents = ['webkitTransitionEnd', 'transitionend'];
      for (let i = 0; i < triggerEvents.length; i += 1) {
        $wrapperEl.trigger(triggerEvents[i]);
      }
    });
  }
}

export { handleSetTransition, handleSetTranslate };
